<template>
  <div class="page">
    <div class="imgss"></div>
    <div class="tail">
      <div class="tailfontsize">
        为了帮助您更好的了解和使用绿萝分发,我们特别为您赠送7天中级VIP体验
      </div>
      <div
        class="taildownload hover-gesture"
        style="font-weight: bold; font-size: 18px; color: #6358ed"
        @click="configStore.downloadFile()"
      >
        立即下载
      </div>
    </div>
    <div class="footer">
      <div class="zopng">
        <div class="greenRoseDistribution">
          <div class="tlos">
            <div class="llo">
              <img src="../../../assets/images/blv.png" alt="" />
            </div>
            <div class="lvff">绿萝分发</div>
            <div class="lks">lV LUO FEN FA</div>
          </div>
        </div>
        <div class="lv">
          <div class="moreContent">
            <div class="gd">更多内容</div>
            <div class="im">
              <div
                class="hover-gesture"
                @click="gotoPage('/regarding')"
                style="background: unset !important"
              >
                关于绿萝
              </div>
              <div
                @click="gotoPage('/noAccount')"
                class="hover-gesture"
                style="background: unset !important"
              >
                新媒体导航
              </div>
              <div
                @click="gotoPage('/')"
                class="hover-gesture"
                style="background: unset !important"
              >
                绿萝学院
              </div>
            </div>
          </div>
          <div class="moreContent">
            <div class="gd">使用手册</div>
            <div class="im">
              <div
                class="hover-gesture"
                style="background: unset !important"
                @click="gotoPage('/teamEdition')"
              >
                团队介绍
              </div>
              <div
                class="hover-gesture"
                style="background: unset !important"
                @click="gotoPage('/vip')"
              >
                产品介绍
              </div>
              <div
                @click="gotoPage('/')"
                class="hover-gesture"
                style="background: unset !important"
              >
                服务保障
              </div>
            </div>
          </div>
        </div>

        <div class="contactUs1">
          <div class="vo">
            <img :src="configStore.businessCooperation" alt="" />
            <view>商务合作</view>
          </div>
          <div class="vo">
            <img :src="configStore.onlineService" alt="" />
            <view>在线客服</view>
          </div>
          <div class="vo">
            <img :src="configStore.officialAccount" alt="" />
            <view>微信公众号</view>
          </div>
        </div>
      </div>
      <div class="Copyright" style="cursor: pointer">
        Copyright©2019-2024深圳市绿萝网络科技有限公司|<span
          @click="goCopyright"
        >
          粤ICP备2024284291号-2</span
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";

const router = useRouter();

import { useConfigStore } from "@/store/index";
const configStore = useConfigStore();

const goCopyright = () => {
  window.open("https://beian.miit.gov.cn/");
};
const gotoPage = (path) => {
  router.push({ path });
  window.scrollTo(0, 0);
};
</script>

<style lang="less" scoped>
/* 可选的样式部分 */
.page {
  width: 100%;

  .tail {
    height: 120px;
    // background: #6358ED;
    background: url("../../../assets/images/Group 222@2x.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 380px;

    .tailfontsize {
      width: 682px;
      height: 30px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 20px;
      color: #ffffff;
      line-height: 23px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .taildownload {
      //margin-left: 376px;
      width: 142px;
      height: 48px;
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      text-align: center;
      line-height: 48px;
      cursor: pointer;
    }
  }

  .header {
    height: 100px;
    background: #ffffff;
    box-shadow: inset 0px -1px 0px 0px rgba(0, 0, 0, 0.1);
    border-radius: 0px 0px 0px 0px;
    display: flex;
    align-items: center;

    .lv {
      padding-left: 386px;
      width: 144px;
      height: 54px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 36px;
      color: #333333;
      line-height: 42px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-right: 96px;
    }

    .navigation {
      display: flex;
      gap: 60px;
      height: 27px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 18px;
      color: #666666;
      line-height: 21px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .client {
      width: 100px;
      height: 36px;
      background: #6358ed;
      border-radius: 4px 4px 4px 4px;
      color: white;
      text-align: center;
      line-height: 36px;
      margin-left: 161px;
    }
  }

  .greenRoseDistribution {
    height: 48px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    font-size: 32px;
    color: #333333;
    line-height: 38px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    //margin-top: 82px;
  }

  .team {
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin: 0 auto;

    .function {
      padding-bottom: 12px;
      width: 240px;
      height: 36px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 24px;
      color: #333333;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    width: 1200px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;

    .client {
      display: flex;
      margin-top: 3px;
    }

    .hs {
      color: #ff8e71;
    }
  }

  .team1 {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 12px;

    .function {
      width: 1200px;
      margin: 0 auto;
      margin-top: 40px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 24px;
      color: #333333;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .distribution {
      display: flex;

      .fpcolor {
        color: #6358ed;
      }
    }
  }

  .tuimg {
    width: 600px;
    height: 340px;
    background: #6358ed;
    border-radius: 12px 12px 12px 12px;
    margin: 0 auto;
    margin-top: 20px;
  }

  .team2 {
    margin: 0 auto;
    width: 1200px;

    .function {
      width: 1200px;
      margin: 0 auto;
      margin-top: 40px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 24px;
      color: #333333;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .ym {
      margin-top: 12px;
      width: 1200px;
      height: 21px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .gl {
      margin-top: 12px;
      width: 1200px;
      height: 63px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #ff6842;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      .im {
        color: #666666;
      }
    }
  }

  .imgss {
    margin-left: 350px;
  }

  .Copyright {
    height: 18px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    line-height: 14px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin: 0 auto;
    padding-bottom: 25px;
  }

  .footer {
    width: 100%;
    background: url("../../../assets/jpg/footerbg.jpg");
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .zopng {
      display: flex;
      justify-content: center;
      gap: 154px;

      .llo {
        img {
          width: 60px;
          height: 120px;
        }
      }

      .greenRoseDistribution {
        .tlos {
          .llo {
            margin: 0 auto;
          }

          .lvff {
            margin-top: 20px;
            width: 160px;
            height: 60px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: bold;
            font-size: 40px;
            color: #ffffff;
            line-height: 47px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }

          .lks {
            height: 24px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            color: #ffffff;
            line-height: 19px;
            letter-spacing: 4px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
        }
      }

      height: 350px;
      display: flex;
      padding-top: 80px;

      .contactUs1 {
        //padding-left: 173px;
        display: flex;
        gap: 50px;

        .vo {
          img {
            width: 120px;
            height: 120px;
          }

          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          display: flex;
          flex-direction: column;
          gap: 15px;
          align-items: center;
        }
      }

      .lv {
        display: flex;
        gap: 143px;

        .moreContent {
          div {
            user-select: none;
            cursor: default;
          }
        }

        .gd {
          width: 80px;
          height: 30px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 20px;
          color: #ffffff;
          line-height: 23px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        .im {
          margin-top: 24px;
          display: flex;
          flex-direction: column;
          gap: 24px;
          height: 21px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }
    }
  }
}
</style>
